var $76fd2ca03adf7a37$exports = {};
$76fd2ca03adf7a37$exports = {
    "Empty": `Gol`
};


export {$76fd2ca03adf7a37$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
